
const PlayStoreQR = () => {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      className="w-24" viewBox="0 0 1045.000000 1045.000000"
      preserveAspectRatio="xMidYMid meet">

      <g transform="translate(0.000000,1045.000000) scale(0.100000,-0.100000)"
        fill="#000000" stroke="none">
        <path d="M190 9595 l0 -665 665 0 665 0 0 665 0 665 -665 0 -665 0 0 -665z
m1140 0 l0 -475 -475 0 -475 0 0 475 0 475 475 0 475 0 0 -475z"/>
        <path d="M570 9595 l0 -285 285 0 285 0 0 285 0 285 -285 0 -285 0 0 -285z"/>
        <path d="M1710 10165 l0 -95 95 0 95 0 0 -190 0 -190 95 0 95 0 0 -95 0 -95
190 0 190 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0
-95 0 0 -95 0 -95 -95 0 -95 0 0 -190 0 -190 95 0 95 0 0 190 0 190 95 0 95 0
0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -285 0 -285 0 0
95 0 95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -190 0 -190 0 0 190 0
190 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 -190 0
-190 95 0 95 0 0 -380 0 -380 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 95 0 95
380 0 380 0 0 95 0 95 380 0 380 0 0 95 0 95 -285 0 -285 0 0 95 0 95 285 0
285 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0
-190 0 -190 -95 0 -95 0 0 -95 0 -95 190 0 190 0 0 -95 0 -95 -95 0 -95 0 0
-95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 -190 0 -190 0 0 -95
0 -95 -380 0 -380 0 0 -190 0 -190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0
-95 95 0 95 0 0 -190 0 -190 95 0 95 0 0 -95 0 -95 -190 0 -190 0 0 -285 0
-285 190 0 190 0 0 -285 0 -285 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -190 0
-190 -380 0 -380 0 0 -190 0 -190 190 0 190 0 0 -95 0 -95 -190 0 -190 0 0
-190 0 -190 95 0 95 0 0 95 0 95 95 0 95 0 0 -190 0 -190 -190 0 -190 0 0
-380 0 -380 285 0 285 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0
-190 0 -190 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 -95 0 -95 95 0 95 0 0 -95
0 -95 190 0 190 0 0 -95 0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 475
0 475 0 0 475 0 475 285 0 285 0 0 95 0 95 190 0 190 0 0 -285 0 -285 95 0 95
0 0 -95 0 -95 -95 0 -95 0 0 -380 0 -380 -95 0 -95 0 0 95 0 95 -570 0 -570 0
0 -95 0 -95 190 0 190 0 0 -95 0 -95 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0
-190 0 -190 190 0 190 0 0 95 0 95 95 0 95 0 0 95 0 95 190 0 190 0 0 -95 0
-95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -285 0 -285 190 0 190 0 0 95 0 95
190 0 190 0 0 -95 0 -95 380 0 380 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0
0 -95 0 -95 190 0 190 0 0 95 0 95 380 0 380 0 0 -95 0 -95 -285 0 -285 0 0
-95 0 -95 285 0 285 0 0 95 0 95 95 0 95 0 0 95 0 95 285 0 285 0 0 95 0 95
95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -285 0 -285 0 0 -95 0 -95 285 0
285 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 285
0 285 95 0 95 0 0 -190 0 -190 95 0 95 0 0 190 0 190 95 0 95 0 0 -95 0 -95
95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 380 0
380 0 0 190 0 190 -95 0 -95 0 0 95 0 95 190 0 190 0 0 190 0 190 -95 0 -95 0
0 -95 0 -95 -285 0 -285 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0 95
0 95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0
95 0 0 -285 0 -285 190 0 190 0 0 95 0 95 95 0 95 0 0 -190 0 -190 -95 0 -95
0 0 -95 0 -95 -190 0 -190 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0
-95 0 -95 475 0 475 0 0 190 0 190 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0
-95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190
0 0 95 0 95 -190 0 -190 0 0 190 0 190 95 0 95 0 0 -95 0 -95 190 0 190 0 0
95 0 95 -190 0 -190 0 0 190 0 190 95 0 95 0 0 95 0 95 -95 0 -95 0 0 285 0
285 95 0 95 0 0 190 0 190 95 0 95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 95 0
95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0
-190 0 -190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 190
0 190 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -190 0 -190 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 285 0 285 -95 0 -95 0 0 -95 0 -95
-285 0 -285 0 0 -95 0 -95 -95 0 -95 0 0 190 0 190 285 0 285 0 0 95 0 95 380
0 380 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 190 0 190 95 0 95 0 0
-95 0 -95 190 0 190 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0 190 0
190 -190 0 -190 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 190 0 190 95
0 95 0 0 -190 0 -190 95 0 95 0 0 285 0 285 -190 0 -190 0 0 -95 0 -95 -190 0
-190 0 0 95 0 95 95 0 95 0 0 95 0 95 -190 0 -190 0 0 95 0 95 95 0 95 0 0
190 0 190 190 0 190 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 285 0 285 95 0 95 0 0 -95 0 -95 95 0
95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 95 0 95 0 0 475 0 475 -95 0 -95 0 0
-95 0 -95 -95 0 -95 0 0 -95 0 -95 -190 0 -190 0 0 95 0 95 95 0 95 0 0 95 0
95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0
-95 0 0 -95 0 -95 -95 0 -95 0 0 285 0 285 -95 0 -95 0 0 -95 0 -95 -95 0 -95
0 0 380 0 380 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 190 0
190 -95 0 -95 0 0 95 0 95 -475 0 -475 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 -95 0 -95 -95
0 -95 0 0 95 0 95 -190 0 -190 0 0 -95 0 -95 190 0 190 0 0 -190 0 -190 -95 0
-95 0 0 95 0 95 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -380 0
-380 0 0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0
-95 0 -95 190 0 190 0 0 190 0 190 -380 0 -380 0 0 -95 0 -95 -95 0 -95 0 0
-95 0 -95 -190 0 -190 0 0 -95 0 -95 -190 0 -190 0 0 95 0 95 95 0 95 0 0 95
0 95 190 0 190 0 0 95 0 95 -190 0 -190 0 0 -95 0 -95 -190 0 -190 0 0 95 0
95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 190 0 190 0 0 -190 0
-190 -95 0 -95 0 0 -95 0 -95 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 -190 0
-190 -190 0 -190 0 0 95 0 95 95 0 95 0 0 285 0 285 -95 0 -95 0 0 190 0 190
95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0
0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0 95 0 95 -380 0 -380 0 0 -285
0 -285 -95 0 -95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95z
m4940 -190 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m570 -95 l0 -190
-190 0 -190 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190z m380 95 l0
-95 95 0 95 0 0 95 0 95 95 0 95 0 0 -95 0 -95 190 0 190 0 0 -95 0 -95 -380
0 -380 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0
-285 0 -285 95 0 95 0 0 -190 0 -190 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95
0 -95 -190 0 -190 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -190 0 -190 0 0 95 0
95 190 0 190 0 0 95 0 95 -285 0 -285 0 0 -285 0 -285 285 0 285 0 0 -95 0
-95 190 0 190 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95
0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 190 0 190 95 0 95 0 0 -95 0
-95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95
95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190 0 -190 95 0 95 0
0 190 0 190 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0
190 0 190 -190 0 -190 0 0 -95 0 -95 95 0 95 0 0 -190 0 -190 95 0 95 0 0 -95
0 -95 -380 0 -380 0 0 190 0 190 190 0 190 0 0 95 0 95 -95 0 -95 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -380 0 -380 -95 0 -95 0 0 95 0 95 -95
0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95
0 0 -95 0 -95 -190 0 -190 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 190 0 190 0 0
95 0 95 95 0 95 0 0 -285 0 -285 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 -95 0
-95 95 0 95 0 0 -95 0 -95 -285 0 -285 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95
-95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 -190 0 -190
95 0 95 0 0 -285 0 -285 190 0 190 0 0 95 0 95 -95 0 -95 0 0 190 0 190 95 0
95 0 0 -190 0 -190 95 0 95 0 0 95 0 95 190 0 190 0 0 -95 0 -95 95 0 95 0 0
-95 0 -95 190 0 190 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 95 0
95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95
-285 0 -285 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0
-95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0
-190 0 -190 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95
0 -95 -95 0 -95 0 0 190 0 190 -380 0 -380 0 0 -95 0 -95 -190 0 -190 0 0 285
0 285 95 0 95 0 0 95 0 95 95 0 95 0 0 -95 0 -95 190 0 190 0 0 285 0 285 -95
0 -95 0 0 -95 0 -95 -190 0 -190 0 0 95 0 95 -95 0 -95 0 0 -190 0 -190 -95 0
-95 0 0 -190 0 -190 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95
0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95 0
-95 95 0 95 0 0 190 0 190 -190 0 -190 0 0 95 0 95 190 0 190 0 0 -95 0 -95
95 0 95 0 0 190 0 190 -190 0 -190 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0
-95 0 0 190 0 190 -95 0 -95 0 0 -285 0 -285 -190 0 -190 0 0 -95 0 -95 285 0
285 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -190 0 -190
0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -190 0 -190 -190 0 -190 0
0 -190 0 -190 95 0 95 0 0 95 0 95 190 0 190 0 0 -95 0 -95 -190 0 -190 0 0
-95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 95 0
95 95 0 95 0 0 190 0 190 95 0 95 0 0 190 0 190 -190 0 -190 0 0 190 0 190 95
0 95 0 0 285 0 285 95 0 95 0 0 -95 0 -95 190 0 190 0 0 95 0 95 -95 0 -95 0
0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -285
0 -285 -285 0 -285 0 0 -190 0 -190 95 0 95 0 0 95 0 95 95 0 95 0 0 -95 0
-95 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -190 0
-190 190 0 190 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -190 0 -190 0 0 95 0 95
-95 0 -95 0 0 95 0 95 -95 0 -95 0 0 475 0 475 95 0 95 0 0 95 0 95 190 0 190
0 0 95 0 95 -285 0 -285 0 0 190 0 190 95 0 95 0 0 -95 0 -95 95 0 95 0 0 285
0 285 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 190 0 190 0 0 285 0 285
95 0 95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 -285 0 -285 95
0 95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 95 0 95 95 0 95 0
0 285 0 285 95 0 95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 95 0 95 0 0 -190 0
-190 95 0 95 0 0 95 0 95 380 0 380 0 0 -95 0 -95 190 0 190 0 0 -95 0 -95
-285 0 -285 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95
0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 285 0 285 0 0 -95 0 -95 190 0 190 0
0 190 0 190 190 0 190 0 0 190 0 190 95 0 95 0 0 95 0 95 -95 0 -95 0 0 95 0
95 190 0 190 0 0 190 0 190 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95
-285 0 -285 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0
0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 -190 0 -190 0 0 95 0
95 190 0 190 0 0 95 0 95 -285 0 -285 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95
95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95
0 95 0 0 -190 0 -190 95 0 95 0 0 190 0 190 95 0 95 0 0 285 0 285 95 0 95 0
0 -285 0 -285 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0 -380 0 -380 -475 0
-475 0 0 95 0 95 -285 0 -285 0 0 -190 0 -190 -95 0 -95 0 0 380 0 380 -95 0
-95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -190 0 -190 0 0 -285 0 -285 95 0 95 0
0 -190 0 -190 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0 -190 0 -190 285 0 285
0 0 190 0 190 -95 0 -95 0 0 95 0 95 95 0 95 0 0 285 0 285 95 0 95 0 0 -285
0 -285 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -190 0
-190 -95 0 -95 0 0 -190 0 -190 95 0 95 0 0 -190 0 -190 -380 0 -380 0 0 95 0
95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -285 0 -285 -95 0 -95 0 0 -95 0 -95
-190 0 -190 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95
0 95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0
0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 190 0 190 -95 0 -95 0 0 -95 0
-95 -95 0 -95 0 0 190 0 190 95 0 95 0 0 380 0 380 -95 0 -95 0 0 95 0 95 190
0 190 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 285 0 285 0 0
190 0 190 95 0 95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 -95 0 -95 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 -285 0 -285 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 95
0 95 0 0 380 0 380 -95 0 -95 0 0 -285 0 -285 -95 0 -95 0 0 285 0 285 95 0
95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 95 0 95 0 0 95 0 95 95 0 95 0 0 -95
0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95
0 0 -190 0 -190 -190 0 -190 0 0 -95 0 -95 285 0 285 0 0 95 0 95 95 0 95 0 0
95 0 95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 190 0 190 0 0 95 0 95
95 0 95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 95 0 95 0 0 95 0 95 95 0 95 0 0
95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 95 0 95 -95
0 -95 0 0 95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 -95 0 -95 95 0 95 0 0
95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 -190 0 -190 95 0 95 0 0 -95 0 -95
95 0 95 0 0 190 0 190 95 0 95 0 0 -190 0 -190 95 0 95 0 0 95 0 95 95 0 95 0
0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 190 0 190 0 0 -95
0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95
95 0 95 0 0 190 0 190 95 0 95 0 0 190 0 190 190 0 190 0 0 285 0 285 95 0 95
0 0 95 0 95 -95 0 -95 0 0 190 0 190 95 0 95 0 0 -190 0 -190 95 0 95 0 0 -95
0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 380 0 380 0 0 -95 0 -95 95 0
95 0 0 -285 0 -285 95 0 95 0 0 190 0 190 95 0 95 0 0 95 0 95 -95 0 -95 0 0
95 0 95 -95 0 -95 0 0 285 0 285 95 0 95 0 0 -95z m-2850 -190 l0 -95 -95 0
-95 0 0 95 0 95 95 0 95 0 0 -95z m0 -380 l0 -95 -95 0 -95 0 0 95 0 95 95 0
95 0 0 -95z m760 -380 l0 -285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z
m-3040 0 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m-1520 -570 l0 -95
95 0 95 0 0 -285 0 -285 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0
-95 0 0 285 0 285 95 0 95 0 0 95 0 95 95 0 95 0 0 -95z m1710 -95 l0 -190
-190 0 -190 0 0 190 0 190 190 0 190 0 0 -190z m-190 -665 l0 -95 -95 0 -95 0
0 95 0 95 95 0 95 0 0 -95z m6840 -1520 l0 -95 -95 0 -95 0 0 -190 0 -190 -95
0 -95 0 0 190 0 190 95 0 95 0 0 95 0 95 95 0 95 0 0 -95z m-7600 -950 l0
-285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z m3800 0 l0 -285 -285 0
-285 0 0 285 0 285 285 0 285 0 0 -285z m3800 0 l0 -285 -285 0 -285 0 0 285
0 285 285 0 285 0 0 -285z m-570 -570 l0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0
-95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 190 0 190 0 0 -95 0 -95
-190 0 -190 0 0 -95 0 -95 -190 0 -190 0 0 190 0 190 -95 0 -95 0 0 -190 0
-190 -95 0 -95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m-380
-190 l0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 190
0 190 -95 0 -95 0 0 95 0 95 190 0 190 0 0 -95z m1520 -1900 l0 -95 -95 0 -95
0 0 95 0 95 95 0 95 0 0 -95z m-950 -475 l0 -190 -95 0 -95 0 0 190 0 190 95
0 95 0 0 -190z m380 95 l0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 -475 0 -475
-95 0 -95 0 0 285 0 285 -190 0 -190 0 0 190 0 190 95 0 95 0 0 -95z m-7030
-665 l0 -190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0 -190z
m1520 95 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m1710 -190 l0 -285
-285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z m1520 95 l0 -190 -380 0 -380
0 0 95 0 95 285 0 285 0 0 95 0 95 95 0 95 0 0 -190z m1140 95 l0 -95 190 0
190 0 0 -95 0 -95 -190 0 -190 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0
-95z m1140 -190 l0 -285 -285 0 -285 0 0 285 0 285 285 0 285 0 0 -285z
m-6650 0 l0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -285 0 -285 -95 0 -95 0 0
95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 95 0 95
95 0 95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0
-95z m3420 -95 l0 -190 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -95 0
-95 0 0 95 0 95 -285 0 -285 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95
0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 95 0 95
95 0 95 0 0 -190z m-3990 -285 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z
m4940 0 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m2470 -190 l0 -95
-190 0 -190 0 0 95 0 95 190 0 190 0 0 -95z m-5890 -190 l0 -95 95 0 95 0 0
-95 0 -95 -285 0 -285 0 0 190 0 190 190 0 190 0 0 -95z m3990 -190 l0 -95
-95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z"/>
        <path d="M3610 9025 l0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -190 0
-190 190 0 190 0 0 95 0 95 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 -380 0
-380 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95
95 0 95 0 0 95 0 95 95 0 95 0 0 -285 0 -285 -95 0 -95 0 0 95 0 95 -190 0
-190 0 0 285 0 285 95 0 95 0 0 95 0 95 -95 0 -95 0 0 285 0 285 95 0 95 0 0
95 0 95 -95 0 -95 0 0 -95 0 -95 -190 0 -190 0 0 -95 0 -95 95 0 95 0 0 -95 0
-95 -95 0 -95 0 0 -95 0 -95 190 0 190 0 0 -95 0 -95 -95 0 -95 0 0 -190 0
-190 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 95 0 95
95 0 95 0 0 -95 0 -95 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 -95 0 -95 95 0
95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 95
0 95 190 0 190 0 0 -190 0 -190 190 0 190 0 0 -95 0 -95 95 0 95 0 0 95 0 95
-95 0 -95 0 0 190 0 190 190 0 190 0 0 -285 0 -285 95 0 95 0 0 285 0 285 -95
0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0
95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190
0 190 0 0 95 0 95 95 0 95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0
190 0 190 -95 0 -95 0 0 190 0 190 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -190 0
-190 95 0 95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95
0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0
0 -95z m380 -380 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m190 -380 l0
-95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m190 -475 l0 -190 95 0 95 0 0
-95 0 -95 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 190
0 190 95 0 95 0 0 -95 0 -95 95 0 95 0 0 190 0 190 95 0 95 0 0 -190z m-190
-950 l0 -190 -95 0 -95 0 0 190 0 190 95 0 95 0 0 -190z m-760 -475 l0 -95
-95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m380 -190 l0 -95 95 0 95 0 0 -95 0
-95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m-570 -190
l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z"/>
        <path d="M5890 9025 l0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95
-95 0 -95 0 0 -190 0 -190 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0
0 -190 0 -190 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0
95 0 95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -190 0 -190 95 0 95 0 0 -285 0
-285 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190 0 -190
-95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -380 0 -380 95 0 95 0 0 95 0 95 95 0 95
0 0 95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 -95 0 -95 190 0 190 0 0 -95 0
-95 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0
-95 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 190
0 190 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 -95
0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0 -95 0
-95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 -95 0 -95 95 0 95 0
0 -95 0 -95 190 0 190 0 0 95 0 95 95 0 95 0 0 95 0 95 -190 0 -190 0 0 190 0
190 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -190 0 -190
-95 0 -95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 190 0
190 0 0 -190 0 -190 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 -190 0 -190 0 0
95 0 95 -190 0 -190 0 0 95 0 95 285 0 285 0 0 -95 0 -95 95 0 95 0 0 95 0 95
95 0 95 0 0 -285 0 -285 95 0 95 0 0 380 0 380 -95 0 -95 0 0 190 0 190 -95 0
-95 0 0 190 0 190 95 0 95 0 0 95 0 95 -190 0 -190 0 0 -190 0 -190 -95 0 -95
0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -190 0 -190 0 0
95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0
95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 95
0 95 95 0 95 0 0 95 0 95 -190 0 -190 0 0 190 0 190 -95 0 -95 0 0 -95 0 -95
-95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0
-95 0 0 -95z m570 -285 l0 -190 -95 0 -95 0 0 190 0 190 95 0 95 0 0 -190z
m380 -95 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m-570 -760 l0 -95 95
0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190
0 -190 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0
95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0
95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m1140 -760 l0 -95 95
0 95 0 0 -190 0 -190 -95 0 -95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 95 0 95
0 0 -95z m-950 -190 l0 -95 -190 0 -190 0 0 -285 0 -285 -95 0 -95 0 0 190 0
190 -95 0 -95 0 0 95 0 95 190 0 190 0 0 95 0 95 190 0 190 0 0 -95z m380
-190 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z"/>
        <path d="M7030 9025 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M7790 8835 l0 -285 95 0 95 0 0 -95 0 -95 190 0 190 0 0 95 0 95 -95
0 -95 0 0 190 0 190 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -285z"/>
        <path d="M8740 7885 l0 -95 -95 0 -95 0 0 -95 0 -95 190 0 190 0 0 190 0 190
-95 0 -95 0 0 -95z"/>
        <path d="M8170 7695 l0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95
190 0 190 0 0 95 0 95 -190 0 -190 0 0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95
0 0 -95z"/>
        <path d="M8740 7315 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M1330 7125 l0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95
-95 0 -95 0 0 -190 0 -190 95 0 95 0 0 -95 0 -95 95 0 95 0 0 190 0 190 95 0
95 0 0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M2660 7125 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M8170 6935 l0 -95 190 0 190 0 0 95 0 95 -190 0 -190 0 0 -95z"/>
        <path d="M8170 6555 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M1330 6365 l0 -95 95 0 95 0 0 -95 0 -95 -190 0 -190 0 0 -95 0 -95
190 0 190 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190 0 -190 95 0 95 0
0 285 0 285 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0
-95z"/>
        <path d="M2090 5415 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M5890 4750 l0 -190 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0 -95 0
-95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -285 0 -285 95 0 95 0 0 190 0 190
95 0 95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190 0 -190 -95 0 -95
0 0 -95 0 -95 190 0 190 0 0 285 0 285 95 0 95 0 0 -190 0 -190 95 0 95 0 0
-95 0 -95 95 0 95 0 0 95 0 95 95 0 95 0 0 -190 0 -190 95 0 95 0 0 190 0 190
95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 475 0 475 95 0 95
0 0 -285 0 -285 95 0 95 0 0 95 0 95 190 0 190 0 0 95 0 95 -190 0 -190 0 0
95 0 95 95 0 95 0 0 285 0 285 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95 0 -95
95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95 -95 0
-95 0 0 95 0 95 -95 0 -95 0 0 95 0 95 190 0 190 0 0 95 0 95 -190 0 -190 0 0
95 0 95 -285 0 -285 0 0 -190z m570 -95 l0 -95 -95 0 -95 0 0 -95 0 -95 95 0
95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 -190 0 -190 0 0 -95 0 -95 -95 0 -95
0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 95 0
95 -190 0 -190 0 0 95 0 95 190 0 190 0 0 95 0 95 95 0 95 0 0 -95z m760 -380
l0 -95 -95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z m-1520 -380 l0 -95 -95 0 -95
0 0 95 0 95 95 0 95 0 0 -95z m950 -380 l0 -95 -95 0 -95 0 0 95 0 95 95 0 95
0 0 -95z"/>
        <path d="M3800 4655 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M950 4465 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M1330 4465 l0 -95 95 0 95 0 0 -95 0 -95 -95 0 -95 0 0 -95 0 -95
190 0 190 0 0 -95 0 -95 -190 0 -190 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95
0 -95 0 0 -190 0 -190 190 0 190 0 0 -95 0 -95 95 0 95 0 0 95 0 95 -95 0 -95
0 0 95 0 95 190 0 190 0 0 95 0 95 95 0 95 0 0 190 0 190 95 0 95 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 190 0 190 -190 0 -190 0 0 -95z"/>
        <path d="M2660 4275 l0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 -190 0
-190 285 0 285 0 0 95 0 95 -190 0 -190 0 0 95 0 95 95 0 95 0 0 95 0 95 95 0
95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M950 4085 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M4370 4085 l0 -95 95 0 95 0 0 -190 0 -190 -95 0 -95 0 0 95 0 95
-95 0 -95 0 0 -95 0 -95 95 0 95 0 0 -285 0 -285 190 0 190 0 0 95 0 95 -95 0
-95 0 0 190 0 190 190 0 190 0 0 95 0 95 -95 0 -95 0 0 95 0 95 95 0 95 0 0
95 0 95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M7410 3135 l0 -95 -95 0 -95 0 0 -190 0 -190 -95 0 -95 0 0 -190 0
-190 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 190 0 190 0 0 95 0 95 95 0
95 0 0 95 0 95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 190 0 190 -95 0 -95 0 0
-95z m190 -380 l0 -95 -95 0 -95 0 0 -95 0 -95 -95 0 -95 0 0 95 0 95 95 0 95
0 0 95 0 95 95 0 95 0 0 -95z"/>
        <path d="M3420 2945 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M8170 2755 l0 -95 -95 0 -95 0 0 -95 0 -95 95 0 95 0 0 95 0 95 190
0 190 0 0 95 0 95 -190 0 -190 0 0 -95z"/>
        <path d="M3990 2185 l0 -95 95 0 95 0 0 -95 0 -95 95 0 95 0 0 -95 0 -95 95 0
95 0 0 95 0 95 95 0 95 0 0 190 0 190 -380 0 -380 0 0 -95z m570 -190 l0 -95
-95 0 -95 0 0 95 0 95 95 0 95 0 0 -95z"/>
        <path d="M6270 2185 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M7410 1995 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M4180 1235 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M5130 9025 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M1330 5225 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M5130 5225 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M8930 5225 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M5130 1425 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M8930 1425 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M8930 9595 l0 -665 665 0 665 0 0 665 0 665 -665 0 -665 0 0 -665z
m1140 0 l0 -475 -475 0 -475 0 0 475 0 475 475 0 475 0 0 -475z"/>
        <path d="M9310 9595 l0 -285 285 0 285 0 0 285 0 285 -285 0 -285 0 0 -285z"/>
        <path d="M10070 8645 l0 -95 -190 0 -190 0 0 -95 0 -95 190 0 190 0 0 95 0 95
95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M9880 5795 l0 -95 190 0 190 0 0 95 0 95 -190 0 -190 0 0 -95z"/>
        <path d="M190 5035 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M1900 2565 l0 -285 95 0 95 0 0 -95 0 -95 190 0 190 0 0 95 0 95 -95
0 -95 0 0 95 0 95 95 0 95 0 0 190 0 190 -95 0 -95 0 0 -190 0 -190 -95 0 -95
0 0 190 0 190 -95 0 -95 0 0 -285z"/>
        <path d="M10070 2185 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
        <path d="M190 855 l0 -665 665 0 665 0 0 665 0 665 -665 0 -665 0 0 -665z
m1140 0 l0 -475 -475 0 -475 0 0 475 0 475 475 0 475 0 0 -475z"/>
        <path d="M570 855 l0 -285 285 0 285 0 0 285 0 285 -285 0 -285 0 0 -285z"/>
        <path d="M1710 380 l0 -190 190 0 190 0 0 190 0 190 -190 0 -190 0 0 -190z"/>
        <path d="M10070 475 l0 -95 95 0 95 0 0 95 0 95 -95 0 -95 0 0 -95z"/>
      </g>
    </svg>
  )
}

export default PlayStoreQR